import { useSelector } from 'react-redux';

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

import { useRecoilValue } from 'recoil';
import { LoggedInState } from './states/LoggedIn';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import { LOGIN_URL } from 'config';

// ==============================|| Root ||============================== //

const Root = () => {
  const loggedIn = useRecoilValue(LoggedInState)
  const customization = useSelector((state) => state.customization);

  if (loggedIn == null) {
    window.location.href = LOGIN_URL
    return
  }

  return (
    <StyledEngineProvider injectFirst>
        <ThemeProvider theme={themes(customization)}>
            <CssBaseline />
            <NavigationScroll>
            <Routes />
            </NavigationScroll>
        </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default Root;